import { LOADING } from "../../../constants/constant";
import {
    APPROVE_OR_REJECT_CARRIER_AGGREGATOR,
    APPROVE_OR_REJECT_CARRIER_AGGREGATOR_SUCCESS,
    APPROVE_OR_REJECT_CARRIER_AGGREGATOR_FAILED,
    APPROVE_OR_REJECT_CARRIER_AGGREGATOR_RESET
} from "../../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: true,
};

export default function approveOrRejectCarrierAggregatorReducer(state = initialState, action) {
  switch (action.type) {
    case APPROVE_OR_REJECT_CARRIER_AGGREGATOR: {
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;
    }

    case APPROVE_OR_REJECT_CARRIER_AGGREGATOR_SUCCESS: {
      let userRes = Object.assign({}, state);
      console.log(
        "approveOrRejectCarrierAggregatorReducer => Case => Success: while approving or rejecting aggregator: " +
          JSON.stringify(action.data)
      );
      userRes.statusCode = action.data.status_code;
      userRes.statusMessage = action.data.status_message;
      userRes.isLoading = false;
      userRes.statusSting = action.data.data;

      return userRes;
    }
    case APPROVE_OR_REJECT_CARRIER_AGGREGATOR_FAILED: {
      console.error(
        "approveOrRejectCarrierAggregatorReducer => Case => Error: while approving or rejecting aggregator: " +
          JSON.stringify(action.error)
      );
      return Object.assign({}, state, action.error);
    }

    case APPROVE_OR_REJECT_CARRIER_AGGREGATOR_RESET: {
      return initialState;
    }

    default:
      return state;
  }
}